import './HvacFormSectionHeader.scss';
import { EnergyEfficiencyClass } from '@belimo-retrofit-portal/logic';
import clsx from 'clsx';
import { constNull, constVoid } from 'fp-ts/function';
import React, { memo } from 'react';
import { CustomToggle } from 'src/modules/common/components/CustomToggle';
import { EnergyEfficiencyTransition } from 'src/modules/common/components/EnergyEfficiencyTransition';

type Props = {
  readonly id: string;
  readonly actual: EnergyEfficiencyClass | null;
  readonly future: EnergyEfficiencyClass | null;
  readonly checked: boolean;
  readonly disabled: boolean;
  readonly readOnly: boolean;
  readonly hasImpact: boolean;
  readonly children: React.ReactNode;
  readonly onToggle: () => void;
  readonly onClick: () => void;
};

export const HvacFormSectionHeader = memo(({
  id,
  actual,
  future,
  checked,
  disabled,
  readOnly,
  hasImpact,
  onToggle,
  onClick,
  children,
}: Props): React.ReactElement => (
  <div
    role="button"
    tabIndex={0}
    onClick={checked ? onClick : constVoid}
    className={clsx({
      'bp-hvac-form-section-header': true,
      'bp-hvac-form-section-header--checked': checked,
      'bp-hvac-form-section-header--weightless': !hasImpact,
    })}
    onKeyDown={constNull}
  >
    <div className="bp-hvac-form-section-header__content">
      <h6 className="bp-hvac-form-section-header__title">
        {children}
      </h6>

      {hasImpact && (
        <div className="bp-hvac-form-section-header__label">
          <EnergyEfficiencyTransition actual={actual} future={future}/>
        </div>
      )}
    </div>

    {!readOnly && (
      <div className="bp-hvac-form-section-header__controls">
        <div className="bp-hvac-form-section-header__toggle">
          <CustomToggle
            id="hvac/form/section/toggle"
            toggled={checked}
            disabled={disabled}
            onClick={stopPropagation}
            onToggle={onToggle}
            hideLabel={true}
          />
        </div>
      </div>
    )}
  </div>
));

function stopPropagation(event: React.MouseEvent): void {
  event.stopPropagation();
}
